import { isNotNullOrEmpty } from './null-checkers';

export const createAddressString = (address: (string | undefined)[]) => {
  return address.filter((line) => isNotNullOrEmpty(line)).join(', ');
};
